export default function Clock() {
  return (
    <svg
      width="57"
      height="65"
      viewBox="0 0 57 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28.3076"
        cy="35.8208"
        r="25.5857"
        stroke="#489E34"
        strokeWidth="5.44377"
      />
      <path
        d="M28.3076 36.9094L28.3076 23.8442"
        stroke="#489E34"
        strokeWidth="5.44377"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="37.5618"
        y1="2.72189"
        x2="19.053"
        y2="2.72189"
        stroke="#489E34"
        strokeWidth="5.44377"
        strokeLinecap="round"
      />
      <line
        x1="46.8164"
        y1="15.6399"
        x2="49.4996"
        y2="12.9567"
        stroke="#489E34"
        strokeWidth="5.44377"
        strokeLinecap="round"
      />
      <circle cx="9.79811" cy="35.8206" r="2.17751" fill="#489E34" />
      <circle cx="28.3079" cy="55.4182" r="2.17751" fill="#489E34" />
      <circle cx="28.3079" cy="16.2229" r="2.17751" fill="#489E34" />
      <circle cx="46.8162" cy="35.8206" r="2.17751" fill="#489E34" />
    </svg>
  )
}
